import IndexContent from "../../../../src/pages/use-cases/page-content/content-and-data-extraction/content-based-process-automation.md";
import * as React from 'react';
export default {
  IndexContent,
  React
};